import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from "@mui/material"
import React, { useState } from "react"
import axios from "axios"
import { Helmet } from "react-helmet"

const Subscribe = () => {
  const [supporter, setSupporter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
  })
  const [disabledButton, setDisabledButton] = useState(false)
  const [errorDialogOpen, setErrorDialogOpen] = useState(false)
  const inputFields = [
    { label: "First Name", stateKey: "firstName" },
    { label: "Last Name", stateKey: "lastName" },
    { label: "Email", stateKey: "email" },
    { label: "Phone Number (optional)", stateKey: "phoneNumber" },
  ]
  const handleSubmit = async (e) => {
    setDisabledButton(true)
    e.preventDefault()
    // Post request to add user
    await axios
      .post("https://move-hp-forward.onrender.com/supporters/add", supporter)
      .then((res) => {
        console.log("Posting: ", res.data)
        setDisabledButton(false)
        setSupporter({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
        })
      })
      .catch((error) => {
        console.log("Uh oh! You have an error, dude: ", error)
        setSupporter({
          firstName: "",
          lastName: "",
          email: "",
          phoneNumber: "",
        })
        setDisabledButton(false)
        setErrorDialogOpen(true)
      })
  }
  return (
    <>
      <Box
        sx={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1a1a1a, #2c5364)",
          color: "white",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: { xs: "2rem", md: "4rem" },
          gap: "2rem",
        }}
      >
        <Helmet>
          <title>Subscribe</title>
        </Helmet>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 900,
            color: "#00e676",
            textAlign: "center",
            letterSpacing: 1,
            mb: 2,
            textShadow: "0 2px 12px rgba(0,0,0,0.45)",
          }}
        >
          Stay in the Loop
        </Typography>
        <Typography
          textAlign="center"
          sx={{ fontWeight: 500, mb: 2, maxWidth: 600 }}
        >
          We cannot achieve this alone. To truly revitalize our town, we require
          your support. Please provide your contact details below to remain
          informed about our collective efforts to{" "}
          <strong>amend and revive Highland Park.</strong> All contact info will
          remain private.
        </Typography>
        <Box
          sx={{
            width: { xs: "100%", md: "60%" },
            bgcolor: "rgba(44,83,100,0.92)",
            borderRadius: "24px",
            boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
            p: 4,
          }}
        >
          <form onSubmit={handleSubmit}>
            <FormControl fullWidth>
              {inputFields.map((field, index) => (
                <TextField
                  key={field.stateKey}
                  fullWidth
                  required={index !== inputFields.length - 1}
                  id={`outlined-${field.stateKey}`}
                  label={field.label}
                  value={supporter[field.stateKey]}
                  type={field.label === "Email" ? "email" : "text"}
                  onChange={(event) =>
                    setSupporter({
                      ...supporter,
                      [field.stateKey]: event.target.value,
                    })
                  }
                  sx={{
                    margin: ".5rem 0",
                    backgroundColor: "#fff",
                    borderRadius: 2,
                  }}
                />
              ))}
              <Button
                sx={{
                  borderRadius: "30px",
                  marginTop: "1rem",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  backgroundColor: "#00e676",
                  color: "#000",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
                  "&:hover": { backgroundColor: "#00c853" },
                }}
                variant="contained"
                color="success"
                type="submit"
                disabled={disabledButton}
              >
                Stay in the loop
              </Button>
            </FormControl>
          </form>
          <Typography
            textAlign="center"
            sx={{ mt: 3, fontWeight: 700 }}
          ></Typography>
        </Box>
      </Box>

      <Dialog open={errorDialogOpen}>
        <DialogTitle>WHOOPS!</DialogTitle>
        <DialogContent>
          Looks like we already have your info. But thanks for double checking!
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErrorDialogOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default Subscribe
